module.exports = __webpack_public_path__ + "img/10.c2858213.png";